"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONBOARDING_CONNECT_COPY = void 0;
exports.ONBOARDING_CONNECT_COPY = {
    CONNECT_DIALOG: 'Connect Arovy to Salesforce via OAuth to build a blueprint of your org.' +
        ' This process is secure and will only sync metadata.',
    CONNECT_NEW_SALESFORCE: 'Connect New Salesforce Instance',
    CONNECT_NEW_SANDBOX: 'Connect New Sandbox Instance',
    CONNECT_YOUR_ORGANIZATION: 'Connect Your Organization',
    PARTIAL_CREDENTIALS: ' credentials.',
    PARTIAL_SALESFORCE_ORGANIZATION_USING: ' Salesforce organization using the ',
    PARTIAL_WILL_LINK_TO: ' will link to the ',
    RETURN_TO_DASHBOARD: 'Return to Dashboard',
    START_OVER: 'Start Over',
    START_SYNC: 'Start Sync',
    WRONG_INSTANCE: 'Wrong Instance? Start Over'
};
//# sourceMappingURL=ONBOARDING_CONNECT_COPY.js.map